import type { Translations } from '../../types'

const dashboardMessages: Translations = {
  "dashboard.admin.header.eyebrow": "",
  "dashboard.admin.header.title": "Dashboard",
  "dashboard.admin.header.subtitle": "",
  "dashboard.admin.header.subtitleSuperAdmin": "",
  "dashboard.admin.actions.refresh": "Aggiorna dati",
  "dashboard.admin.actions.refreshing": "Aggiornamento...",
  "dashboard.admin.actions.retry": "Riprova",
  "dashboard.admin.messages.missingToken": "Sessione non disponibile. Effettua di nuovo il login.",
  "dashboard.admin.messages.loadError": "Errore caricamento dashboard",
  "dashboard.admin.messages.partialLoadError": "Alcuni dati non sono disponibili in questo momento.",
  "dashboard.admin.messages.loadProductsError": "Errore caricamento prodotti",
  "dashboard.admin.messages.loadStatusUpgradesError": "Errore caricamento aggiornamenti servizi",
  "dashboard.admin.messages.loadSystemStatusError": "Errore caricamento stato sistema",
  "dashboard.admin.messages.loadReadinessError": "Errore caricamento readiness operativa",
  "dashboard.admin.upgrade.title": "Aggiornamenti servizi rilevati",
  "dashboard.admin.upgrade.subtitle": "{{count}} servizio/i hanno cambiato versione o runtime.",
  "dashboard.admin.upgrade.item": "{{service}}: {{previous}} → {{next}}",
  "dashboard.admin.upgrade.dismiss": "Nascondi",
  "dashboard.admin.upgrade.unknownVersion": "sconosciuta",
  "dashboard.admin.upgrade.toastDetected": "Rilevato aggiornamento servizi: {{count}}",

  "dashboard.admin.kpi.ordersToday.label": "Ordini oggi",
  "dashboard.admin.kpi.ordersToday.helper": "Nuovi ordini registrati oggi",
  "dashboard.admin.kpi.ordersPending.label": "Ordini in attesa",
  "dashboard.admin.kpi.ordersPending.helper": "Ordini ancora da processare",
  "dashboard.admin.kpi.ordersPending.helperClear": "Nessun ordine in attesa",
  "dashboard.admin.kpi.ordersPending.helperWarning": "{{count}} ordini in attesa da oltre 24 ore",
  "dashboard.admin.kpi.revenue.label": "Fatturato",
  "dashboard.admin.kpi.revenue.helper": "Totale ordini pagati o spediti",
  "dashboard.admin.kpi.productsActive.label": "Prodotti attivi",
  "dashboard.admin.kpi.productsActive.helper": "SKU pubblicati e acquistabili",
  "dashboard.admin.kpi.productsOutOfStock.label": "Prodotti esauriti",
  "dashboard.admin.kpi.productsOutOfStock.helper": "Prodotti attivi con stock a zero",
  "dashboard.admin.kpi.productsOutOfStock.helperClear": "Nessun prodotto esaurito",
  "dashboard.admin.kpi.state.neutral": "Nessuna criticità",
  "dashboard.admin.kpi.state.success": "OK",
  "dashboard.admin.kpi.state.warning": "Attenzione",
  "dashboard.admin.kpi.state.critical": "Critico",

  "dashboard.admin.insights.title": "Da fare subito",
  "dashboard.admin.insights.subtitle": "Solo urgenze che richiedono attenzione immediata.",
  "dashboard.admin.insights.empty": "Nessuna criticità urgente al momento.",
  "dashboard.admin.insights.ordersOlderThan24h.title": "{{count}} ordini in attesa da oltre 24h",
  "dashboard.admin.insights.ordersOlderThan24h.description": "Controlla i pagamenti bloccati o le conferme mancanti.",
  "dashboard.admin.insights.pendingOrdersBacklog.title": "{{count}} ordini in attesa",
  "dashboard.admin.insights.pendingOrdersBacklog.description": "Riduci la coda ordini per evitare blocchi operativi.",
  "dashboard.admin.insights.openTickets.title": "{{count}} ticket aperti o in lavorazione",
  "dashboard.admin.insights.openTickets.description": "Molti ticket richiedono risposta.",
  "dashboard.admin.insights.systemIssues.title": "{{count}} servizi di sistema con criticità",
  "dashboard.admin.insights.systemIssues.description": "Controlla subito stato tecnico e log di servizio.",

  "dashboard.admin.todo.title": "Cose da fare",
  "dashboard.admin.todo.subtitle": "Attività operative da gestire nel flusso quotidiano.",
  "dashboard.admin.todo.priority": "Priorità alta",
  "dashboard.admin.todo.inControl": "Sotto controllo",
  "dashboard.admin.todo.summaryAttention": "{{count}} attività richiedono attenzione immediata",
  "dashboard.admin.todo.summaryAllClear": "Nessuna criticità attiva",
  "dashboard.admin.todo.additionalSummary": "+{{count}} altre priorità",
  "dashboard.admin.todo.openAction": "Apri elenco",
  "dashboard.admin.todo.ordersToFulfill.title": "Ordini da evadere",
  "dashboard.admin.todo.ordersToFulfill.description": "{{count}} ordini pagati in attesa di spedizione.",
  "dashboard.admin.todo.ordersToFulfill.emptyDescription": "Nessun ordine da evadere in questo momento.",
  "dashboard.admin.todo.ordersToFulfill.attentionSummary": "{{count}} ordini da evadere",
  "dashboard.admin.todo.ordersToFulfill.cta": "Vai agli ordini",
  "dashboard.admin.todo.productsWithoutStock.title": "Prodotti senza stock",
  "dashboard.admin.todo.productsWithoutStock.description": "{{count}} SKU attivi non disponibili alla vendita.",
  "dashboard.admin.todo.productsWithoutStock.emptyDescription": "Nessun prodotto attivo senza stock.",
  "dashboard.admin.todo.productsWithoutStock.attentionSummary": "{{count}} prodotti senza stock",
  "dashboard.admin.todo.productsWithoutStock.cta": "Vai ai prodotti",
  "dashboard.admin.todo.productsWithoutCategory.title": "Prodotti senza categoria",
  "dashboard.admin.todo.productsWithoutCategory.description": "{{count}} articoli richiedono categorizzazione.",
  "dashboard.admin.todo.productsWithoutCategory.emptyDescription": "Tutti i prodotti risultano categorizzati.",
  "dashboard.admin.todo.productsWithoutCategory.attentionSummary": "{{count}} prodotti da categorizzare",
  "dashboard.admin.todo.productsWithoutCategory.cta": "Apri categorizzazione",
  "dashboard.admin.todo.openTickets.title": "Ticket aperti",
  "dashboard.admin.todo.openTickets.description": "{{count}} richieste assistenza aperte o in lavorazione.",
  "dashboard.admin.todo.openTickets.emptyDescription": "Nessun ticket aperto o in lavorazione.",
  "dashboard.admin.todo.openTickets.attentionSummary": "{{count}} ticket aperti",
  "dashboard.admin.todo.openTickets.cta": "Vai ai ticket",

  "dashboard.admin.quickActions.title": "Azioni rapide",
  "dashboard.admin.quickActions.subtitle": "Accesso rapido alle operazioni principali e alle urgenze attive.",
  "dashboard.admin.quickActions.managePendingOrders.title": "Gestisci ordini in attesa",
  "dashboard.admin.quickActions.managePendingOrders.description": "{{count}} ordini pagati da evadere.",
  "dashboard.admin.quickActions.manageOutOfStock.title": "Visualizza prodotti senza stock",
  "dashboard.admin.quickActions.manageOutOfStock.description": "{{count}} prodotti richiedono riassortimento.",
  "dashboard.admin.quickActions.openTickets.title": "Vai ai ticket aperti",
  "dashboard.admin.quickActions.openTickets.description": "{{count}} ticket richiedono risposta.",
  "dashboard.admin.quickActions.createProduct.title": "Crea prodotto",
  "dashboard.admin.quickActions.createProduct.description": "Apri catalogo prodotti e crea un nuovo articolo.",
  "dashboard.admin.quickActions.createCategory.title": "Crea categoria",
  "dashboard.admin.quickActions.createCategory.description": "Apri categorie e aggiungi una nuova tassonomia.",
  "dashboard.admin.quickActions.openProducts.title": "Vai a prodotti",
  "dashboard.admin.quickActions.openProducts.description": "Gestisci catalogo, stato e stock prodotti.",
  "dashboard.admin.quickActions.openOrders.title": "Vai a ordini",
  "dashboard.admin.quickActions.openOrders.description": "Controlla ordini, pagamenti e spedizioni.",

  "dashboard.admin.activity.actions.viewAll": "Vedi tutto",
  "dashboard.admin.activity.orders.title": "Ultimi ordini",
  "dashboard.admin.activity.orders.subtitle": "Attività ordini più recente",
  "dashboard.admin.activity.orders.empty": "Nessun ordine disponibile.",
  "dashboard.admin.activity.products.title": "Ultimi prodotti modificati",
  "dashboard.admin.activity.products.subtitle": "Modifiche catalogo recenti",
  "dashboard.admin.activity.products.empty": "Nessun prodotto disponibile.",
  "dashboard.admin.activity.products.stockLabel": "Stock: {{count}}",

  "dashboard.admin.systemStatus.title": "Stato sistema",
  "dashboard.admin.systemStatus.subtitle": "Stato sintetico dei servizi critici.",
  "dashboard.admin.systemStatus.empty": "Nessun dato tecnico disponibile.",
  "dashboard.admin.systemStatus.smtp": "Email (SMTP)",
  "dashboard.admin.systemStatus.payments": "Pagamenti",
  "dashboard.admin.systemStatus.api": "API",
  "dashboard.admin.systemStatus.jobs": "Job e queue",
  "dashboard.admin.systemStatus.state.ok": "OK",
  "dashboard.admin.systemStatus.state.warning": "Attenzione",
  "dashboard.admin.systemStatus.state.error": "Errore",
  "dashboard.admin.systemStatus.state.unknown": "N/D",
  "dashboard.admin.systemStatus.message.ok": "Operativo",
  "dashboard.admin.systemStatus.message.warning": "Degradato",
  "dashboard.admin.systemStatus.message.error": "Errore rilevato",
  "dashboard.admin.systemStatus.message.unknown": "Dati non disponibili",
  "dashboard.admin.systemStatus.message.okLastCheck": "Ultimo controllo riuscito: {{at}}",
  "dashboard.admin.systemStatus.message.warningLastCheck": "Degradato · ultimo controllo: {{at}}",

  "dashboard.admin.readiness.title": "Readiness operativa",
  "dashboard.admin.readiness.subtitle": "Controlli guidati per setup e go-live operativo.",
  "dashboard.admin.readiness.empty": "Nessun controllo readiness disponibile.",
  "dashboard.admin.readiness.state.ok": "OK",
  "dashboard.admin.readiness.state.warning": "Attenzione",
  "dashboard.admin.readiness.state.error": "Errore",
  "dashboard.admin.readiness.openAction": "Apri impostazioni",
  "dashboard.admin.readiness.providerStatusTitle": "Validazione provider",
  "dashboard.admin.readiness.backupStatusTitle": "Stato backup",
  "dashboard.admin.readiness.checkedAt": "Controllato alle: {{value}}",
  "dashboard.admin.readiness.neverChecked": "Nessun timestamp di verifica",

  "dashboard.cards.supportRequests": "Richieste assistenza",
  "dashboard.cards.slides": "Slide hero",
  "dashboard.cards.menu": "Voci menu",
  "dashboard.requests.title": "Andamento richieste",
  "dashboard.requests.count": "{{count}} richieste",
  "dashboard.requests.empty": "Ancora nessuna richiesta.",
  "dashboard.latestSlides.title": "Ultime slide",
  "dashboard.latestSlides.edit": "Modifica",
  "dashboard.latestSlides.empty": "Nessuna slide",

  "dashboard.customer.auth.missingToken": "Sessione dashboard non disponibile. Effettua di nuovo il login.",
  "dashboard.customer.hero.eyebrow": "Area cliente",
  "dashboard.customer.hero.greetingPrefix": "Bentornato",
  "dashboard.customer.hero.defaultName": "cliente",
  "dashboard.customer.hero.subtitleWithOrders": "Hai {{count}} ordini attivi o recenti",
  "dashboard.customer.hero.subtitleEmpty": "Non hai ancora effettuato ordini",
  "dashboard.customer.hero.actions.goToShop": "Vai allo shop",
  "dashboard.customer.hero.actions.myOrders": "I miei ordini",

  "dashboard.customer.onboarding.title": "Parti dal tuo primo acquisto",
  "dashboard.customer.onboarding.description": "Dopo il primo ordine vedrai qui stato ordini, fatture e pagamenti.",
  "dashboard.customer.onboarding.howItWorks": "Come funziona",

  "dashboard.customer.cards.totalOrders": "Ordini totali",
  "dashboard.customer.cards.ordersInProgress": "Ordini in corso",
  "dashboard.customer.cards.totalPaid": "Totale speso",
  "dashboard.customer.cards.availableInvoices": "Fatture disponibili",

  "dashboard.customer.orders.title": "I tuoi ordini",
  "dashboard.customer.orders.subtitle": "Monitora i tuoi ordini recenti e apri rapidamente il dettaglio.",
  "dashboard.customer.orders.loading": "Caricamento ordini...",
  "dashboard.customer.orders.emptyTitle": "Nessun ordine al momento",
  "dashboard.customer.orders.emptyDescription": "Quando effettuerai un acquisto vedrai qui stato, importo e tracking.",
  "dashboard.customer.orders.columns.date": "Data",
  "dashboard.customer.orders.columns.total": "Totale",
  "dashboard.customer.orders.actions.viewAll": "Vedi tutti",
  "dashboard.customer.orders.actions.viewDetail": "Vedi dettagli",
  "dashboard.customer.orders.actions.trackOrder": "Traccia ordine",
  "dashboard.customer.orders.actions.discoverProducts": "Scopri i prodotti",
  "dashboard.customer.orders.trackingUnavailable": "Tracking non disponibile",

  "dashboard.customer.invoices.title": "Pagamenti e fatture",
  "dashboard.customer.invoices.subtitle": "Consulta pagamenti, fatture e accesso rapido all'ordine collegato.",
  "dashboard.customer.invoices.loading": "Caricamento fatture...",
  "dashboard.customer.invoices.emptyTitle": "Nessuna fattura disponibile",
  "dashboard.customer.invoices.emptyDescription": "Le fatture appariranno qui dopo la conferma del pagamento.",
  "dashboard.customer.invoices.fields.order": "Ordine",
  "dashboard.customer.invoices.fields.date": "Data fattura",
  "dashboard.customer.invoices.fields.total": "Importo",
  "dashboard.customer.invoices.fields.paymentStatus": "Stato pagamento",
  "dashboard.customer.invoices.paymentStatus.pending": "In attesa",
  "dashboard.customer.invoices.paymentStatus.paid": "Pagato",
  "dashboard.customer.invoices.paymentStatus.cancelled": "Annullato",
  "dashboard.customer.invoices.actions.openPdf": "Scarica fattura",
  "dashboard.customer.invoices.actions.openingPdf": "Apro fattura...",
  "dashboard.customer.invoices.actions.openOrder": "Apri ordine",
  "dashboard.customer.invoices.actions.viewOrders": "Vedi i tuoi ordini",

  "dashboard.customer.quickActions.title": "Azioni rapide",
  "dashboard.customer.quickActions.subtitle": "Accesso immediato alle operazioni più frequenti del tuo account.",
  "dashboard.customer.quickActions.items.editProfile": "Modifica profilo",
  "dashboard.customer.quickActions.items.editProfileDescription": "Aggiorna i tuoi dati personali e i recapiti.",
  "dashboard.customer.quickActions.items.manageAddresses": "Gestisci indirizzi",
  "dashboard.customer.quickActions.items.manageAddressesDescription": "Controlla e aggiorna gli indirizzi salvati.",
  "dashboard.customer.quickActions.items.paymentsAndInvoices": "Metodi di pagamento",
  "dashboard.customer.quickActions.items.paymentsAndInvoicesDescription": "Consulta stato pagamenti e fatture associate.",
  "dashboard.customer.quickActions.items.contactSupport": "Contatta assistenza",
  "dashboard.customer.quickActions.items.contactSupportDescription": "Apri un ticket o rispondi a una richiesta in corso.",
  "dashboard.customer.quickActions.items.returnsAndRefunds": "Resi e rimborsi",
  "dashboard.customer.quickActions.items.returnsAndRefundsDescription": "Richiedi supporto su resi, annulli e rimborsi.",

  "dashboard.customer.recentlyViewed.title": "Ultimi prodotti visti",
  "dashboard.customer.recentlyViewed.subtitle": "Riprendi velocemente i prodotti che hai consultato di recente.",
  "dashboard.customer.recentlyViewed.emptyTitle": "Ancora nessun prodotto visualizzato",
  "dashboard.customer.recentlyViewed.emptyDescription": "Naviga lo shop: qui troverai subito i prodotti visitati di recente.",
  "dashboard.customer.recentlyViewed.noImage": "Nessuna immagine",
  "dashboard.customer.recentlyViewed.viewedAtPrefix": "Visto il",
  "dashboard.customer.recentlyViewed.priceOnRequest": "Prezzo su richiesta",
  "dashboard.customer.recentlyViewed.actions.exploreCatalog": "Esplora catalogo",
  "dashboard.customer.recentlyViewed.actions.openProduct": "Vai al prodotto",

  "dashboard.customer.messages.loadError": "Errore caricamento dashboard cliente",
  "dashboard.customer.messages.openInvoiceError": "Errore apertura fattura"
}

export default dashboardMessages
